import React from 'react';
import {SharePriceCompactViewProps} from './config';
import {YourIR} from 'yourir-react';
import {appID} from './constants';
import ProcessStepper from "../ProcessStepper";

const SharePriceCompactView = (props: SharePriceCompactViewProps) => {
    return (
        <div className="module module--investor-tile">
            <div className="module__content ">
                <a href={props.linkurl !== '' ? props.linkurl : undefined} className={`investor-tile js-loading fn_investor-tile fn_yourir ${props.backgroundcolor} ${props.transparent}`}>
                    <div className="investor-tile__content-container">
                        <YourIR appID={appID} hide={false}>
                            <div className="investor-tile__share-price-container">
                                <div className="investor-tile__share-label">{props.sharelabel}</div>
                                <div className="investor-tile__share-price">
                                    <div className="price fn_price" data-yourir="price"></div>
                                </div>
                                <div className="investor-tile__share-price-update-time">
                                    {props.datetext}
                                    <span data-yourir="currentTime format=' DD MMM YYYY H:mm'"></span>
                                </div>
                            </div>

                        </YourIR>
                    </div>
                </a>
            </div>
        </div>
    )
};

export default SharePriceCompactView;

SharePriceCompactView.defaultProps = {
    linkurl : '',
    sharelabel : '',
    datetext : '',
    backgroundcolor : '',
    transparent : '',
};
